import {CompositionFont} from '@dms/api/sales';
import {CompositionTextLayer} from '@dms/api/shared';

export const REGULAR_FONT_WEIGHT = 400;
export const BOLD_FONT_WEIGHT = 700;

export type FontFacePatch = Pick<CompositionTextLayer, 'fontId' | 'fontWeight'>;

/**
 * Text layer patch that selects an uploaded face. The layer weight follows the face weight, so the
 * browser never synthesises bold for a face the server renders as is.
 */
export const toFontFacePatch = (face: CompositionFont): FontFacePatch => ({
  fontId: face.id,
  fontWeight: face.weight === BOLD_FONT_WEIGHT ? BOLD_FONT_WEIGHT : REGULAR_FONT_WEIGHT,
});
